export default function (price, currency) {
  let priceNumber = ((price - 0).toFixed(2) * 100) % 100 === 0 ? (price - 0).toFixed(0) : (price - 0).toFixed(2)

  switch (currency) {
    case 'EUR':
      return priceNumber + '€'
    case 'USD':
      return '$' + priceNumber
    case 'CHF':
      return priceNumber + 'Fr'
    case 'GBP':
      return '£' + priceNumber
    case 'CAD':
      return 'C$' + priceNumber
    case 'AUD':
      return 'A$' + priceNumber
    case 'BRL':
      return 'R$' + priceNumber
    case 'NZD':
      return 'NZ$' + priceNumber
    case 'JPY':
      return '¥' + priceNumber
  }

  return priceNumber + currency
}
